import React from 'react'
import styled from 'styled-components'
import {BsArrowUpRightSquareFill} from 'react-icons/bs'
import zigler from '../assets/zigleraro.jpeg'
import royal from '../assets/royalglass.jpg'
import sil from '../assets/siliconlab.jpeg'
import pff from '../assets/pff_logo.jpg'
const Card = styled.div`
    width:400px;
    border-radius:10px;
    box-shadow: 0 0 10px rgba(0,0,0.1);
    padding 12px 16px;
    justify-content:space-between;
    position:relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    gap: 12px;
    transition: all 0.3s ease-in-out;

    &:hover{
        box-shadow: 0 0 20px rgba(0,0,0.2);
        transform: translateY(-10px);

    }
    @media (max-width: 768px){
        padding: 10px;
        gap:8px;
        width: 300px;
    }
    border: 0.1px solid #800080;
    box-shadow: rgba(23,92,230,0.15) 0px 4px 24px;
`;

const Top=styled.div`
    display:flex;
    gap: 12px;
    width: 100%;
`;

const Logo=styled.img`
    height:100px;
    background-color:#000;
    border-radius:10px;
    margin-top:4px;
    margin-bottom:4px;
    margin-left:4px;
    @media (max-width: 768px){
        heigth:40px;
    }
`;

const Body=styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

const Role=styled.div`
    font-size:18px;
    font-weigth:600;
    color:#b3b3b3;
    @media (max-width: 768px){
        font-size:16px;
    }
`;

const Company=styled.div`
    font-size:16px;
    font-weigth:500;
    color:#999999;
    @media (max-width: 768px){
        font-size:12px;
    }
`;

const Duration=styled.div`
    font-size:12px;
    font-weigth:400;
    color:#808080;
    @media (max-width: 768px){
        font-size:10px;
    }
`;

const WorkExp = () => {
  return (
    <div name="work" className="bg-gradient-to-b  from-gray-800 to-black w-full h-screen py-20 text-white md:h-screen">
        <div className="max-w-screen-lg mx-auto p-4 flex flex-col justify-center w-full h-full text-white">
            <div className="pb-8">
            <p className="text-4xl font-bold inline border-b-4 border-gray-500 text-white">Work Experience</p>
            {/* <p className="py-6">These are some of my works</p> */}
            </div>
            <div className='py-5'>
            <Card>
        <Top>
            <Logo src={pff} className=' h-20 w-20'/>
            <Body>
                <Role>Robotics & Engineering Co-op</Role>
                <Company>Piaggio Fast Forward</Company>
                <Duration>July 2024 - Present</Duration>
                <a href='https://sites.google.com/husky.neu.edu/hussain-kanchwala/piaggio-fast-forward' className="flex  items-center w-full text-blue-500" target='_blank' rel="noreferrer">
                <>
                    <div className='px-1'>Learn More</div><BsArrowUpRightSquareFill size={30}/>
                </>
                    </a>
            </Body>
        </Top>
        {/* <Description></Description> */}
        </Card>
        </div>
            <div className='py-5 px-10 md:px-20'>
            <Card>
        <Top>
            <Logo src={sil}/>
            <Body>
                <Role>Silicon Synapse Lab</Role>
                <Company>Student Researcher</Company>
                <Duration>June 2023 - February 2024</Duration>
                <a href='https://sites.google.com/husky.neu.edu/hussain-kanchwala/silicon-synapse-lab' className="flex  items-center w-full text-blue-500" target='_blank' rel="noreferrer">
                <>
                    <div className='px-1'>Learn More</div><BsArrowUpRightSquareFill size={30}/>
                </>
                    </a>
            </Body>
        </Top>
        {/* <Description></Description> */}
        </Card>
        </div>
        <div className='py-5'>
            <Card>
        <Top>
            <Logo src={zigler}/>
            <Body>
                <Role>Ziegler Aerospace</Role>
                <Company>Intern</Company>
                <Duration>July 2021 - August 2021</Duration>
                <a href='https://sites.google.com/husky.neu.edu/hussain-kanchwala/ziegler-aerospace' className="flex  items-center w-full text-blue-500" target='_blank' rel="noreferrer">
                <>
                    <div className='px-1'>Learn More</div><BsArrowUpRightSquareFill size={30}/>
                </>
                    </a>
            </Body>
        </Top>
        {/* <Description></Description> */}
        </Card>
        </div>
        <div className='py-5 px-10 md:px-20'>
            <Card>
        <Top>
            <Logo src={royal}/>
            <Body>
                <Role>Royal Glass</Role>
                <Company>Proprietor</Company>
                <Duration>April 2018 - July 2022</Duration>
                <a href='https://sites.google.com/husky.neu.edu/hussain-kanchwala/royal-glass' className="flex  items-center w-full text-blue-500" target='_blank' rel="noreferrer">
                <>
                    <div className='px-1'>Learn More</div><BsArrowUpRightSquareFill size={30}/>
                </>
                    </a>
            </Body>
        </Top>
        {/* <Description></Description> */}
        </Card>
        </div>
            </div>
    </div>
  )
}

export default WorkExp